<template>
  <div v-if="loadedMatrixPOI && loadedMatrixAreas && loadedMatrixForVROOM">
    <div class="centerTimePicker text-center pt-lg-4 px-lg-5">
      <!-- <h4
        class="px-4"
        :class="{
          'mobile-subtitle': !isLarge,
        }"
      >
        Le peculiarità dell’ambiente locale si possono sicuramente apprezzare
        meglio percorrendo uno degli itinerari già esistenti in zona oppure
        creandone uno nuovo in base ai propri interessi specifici.
      </h4> -->

      <div v-if="!isLarge" class="mb-3">
        <div class="col-12">
          <Button
            size="small"
            type="primary"
            v-on:click="goToSelezionaItinerarioPredefinito()"
            class="button_font my-2 w-75"
            >Seleziona un itinerario proposto da noi
          </Button>
        </div>

        <div class="col-12">
          <Button
            size="small"
            type="primary"
            v-on:click="goToCreaItinerario()"
            class="button_font my-2 w-75"
            >Crea un nuovo itinerario
          </Button>
        </div>

        <div class="col-12">
          <Button
            size="small"
            type="primary"
            v-on:click="goToInserisciCodiceItinerario()"
            class="button_font my-2 w-75"
            >Recupera un itinerario che hai già creato
          </Button>
        </div>
      </div>

      <div
        class="postcardpercorsi light  mx-2"
        :class="!isLarge ? 'cursor-pointer ' : ''"
        v-on:click="!isLarge ? selectDefaultPath() : null"
      >
        <div
          class="postcardpercorsi__text"
          id="selezionaItinerarioPredefinitoMobile"
        >
          <div class="h-100">
            <h1
              class="white"
              :class="{
                postcardpercorsi__title__mobile: !isLarge,
                postcardpercorsi__title: isLarge,
              }"
            >
              Seleziona uno degli itinerari proposti da noi
            </h1>

            <div v-if="isLarge" class="postcardpercorsipredefiniti__bar"></div>
            <div class="postcardpercorsi__preview-txt">
              Selezionando questa opzione è possibile visualizzare alcuni degli
              itinerari già esistenti nel nostro territorio. Si tratta di
              percorsi che nella gran parte dei casi possono essere svolti in
              autonomia, seguendo le indicazioni riportate sul portale, ma in
              alcuni casi fanno parte delle
              <b>escursioni guidate proposte dal Geodidalab</b> alle scuole o al
              pubblico generico per scoprire le peculiarità geologiche e
              naturalistiche locali.
            </div>
            <div :class="{ 'text-left': isLarge, 'text-center': !isLarge }">
              <Button
                size="small"
                type="primary"
                v-on:click="isLarge ? selectDefaultPath() : null"
                class="button_font mt-5"
                >Seleziona itinerario
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div class="postcardpercorsi light white mx-2 d-none d-lg-block">
        <div class="postcardpercorsi__text">
          <div class="row" v-if="enabledRadioCreatePathOrInsertCode === '1'">
            <div class="col-6">
              <h1 class="postcardpercorsi__title white">
                Crea un nuovo itinerario
              </h1>
              <div
                v-if="isLarge"
                class="postcardpercorsipredefiniti__bar"
              ></div>
              <div class="postcardpercorsi__preview-txt mb-3">
                Creando un nuovo percorso hai la possibilità di inserire le
                attività che più ti interessano e i posti che più vuoi visitare
                in modo tale da rendere la tua esperienza ancora più unica!
              </div>

              <div class="text-left">Quanto tempo hai a disposizione?</div>

              <div v-if="!this.$store.getters.viewFeaturesProgettoTesi">
                <ul class="postcardpercorsi__tagbox" v-if="this.config">
                  <li
                    v-for="timeSlot in this.config.omekaIDs.timeSlots"
                    :key="timeSlot"
                    :class="
                      $store.getters.timeSlotRadio === timeSlot
                        ? 'tag__item__selected'
                        : 'tag__item__unselected'
                    "
                    v-on:click="selectTimeSlot(timeSlot)"
                  >
                    <i
                      v-if="$store.getters.timeSlotRadio === timeSlot"
                      class="fas fa-check mr-2"
                    ></i
                    >{{ timeSlot }} ore
                  </li>
                  <li
                    :class="
                      $store.getters.timeSlotRadio === 'other'
                        ? 'tag__item__selected'
                        : 'tag__item__unselected'
                    "
                    v-on:click="selectTimeSlot('other')"
                  >
                    <i
                      v-if="$store.getters.timeSlotRadio === 'other'"
                      class="fas fa-check mr-2"
                    ></i
                    >Altro (fascia oraria personalizzata)
                  </li>
                </ul>
              </div>

              <div v-if="$store.getters.timeSlotRadio === 'other'">
                <div class="row mt-4">
                  <!-- <h6 class="col-12 text-left">
                    <b>Seleziona il tempo che hai a disposizione</b>
                  </h6> -->
                  <div
                    v-if="!okTimeAvailable"
                    class="col-12 errorMessage fade-in-text text-left"
                  >
                    <h5><b>Devi inserire una fascia oraria corretta!</b></h5>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col-12 text-left">
                    <b class="mr-3">dalle ore</b>
                    <vue-timepicker
                      v-model="startAvailableTimeValue"
                      format="HH:mm"
                    ></vue-timepicker>
                  </div>
                </div>

                <div class="row align-items-center pt-3 pb-3">
                  <div class="col-12 text-left">
                    <b class="mr-3">alle ore</b>
                    <vue-timepicker
                      v-model="endAvailableTimeValue"
                      format="HH:mm"
                    ></vue-timepicker>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-12 text-left">
                    Hai selezionato di essere disponibile dalle ore
                    <template v-if="startAvailableTimeValue.HH === ''">00</template>
                    <template v-else>{{ startAvailableTimeValue.HH }}</template>
                     e
                     <template v-if="startAvailableTimeValue.mm === ''">00</template>
                    <template v-else>{{ startAvailableTimeValue.mm }}</template>
                    
                    alle ore

                    <template v-if="endAvailableTimeValue.HH === ''">00</template>
                    <template v-else>{{ endAvailableTimeValue.HH }}</template>
                     e
                     <template v-if="endAvailableTimeValue.mm === ''">00</template>
                    <template v-else>{{ endAvailableTimeValue.mm }}</template>.
                  </div>
                </div>
              </div>

              <div v-if="forOrSixHoursSelected">
                <div class="mt-3 text-left">
                  Dicci quando preferiresti svolgere le attività
                </div>
                <ul class="postcardpercorsi__tagbox">
                  <li
                    :class="
                      $store.getters.partOfDaySelectedRadio === 'mattina'
                        ? 'tag__item__selected'
                        : 'tag__item__unselected'
                    "
                    v-on:click="choosePartOfDay('mattina')"
                  >
                    <i
                      v-if="$store.getters.partOfDaySelectedRadio === 'mattina'"
                      class="fas fa-check mr-2"
                    ></i
                    >Mattina
                  </li>
                  <li
                    :class="
                      $store.getters.partOfDaySelectedRadio === 'pomeriggio'
                        ? 'tag__item__selected'
                        : 'tag__item__unselected'
                    "
                    v-on:click="choosePartOfDay('pomeriggio')"
                  >
                    <i
                      v-if="
                        $store.getters.partOfDaySelectedRadio === 'pomeriggio'
                      "
                      class="fas fa-check mr-2"
                    ></i
                    >Pomeriggio
                  </li>
                  <li
                    :class="
                      $store.getters.partOfDaySelectedRadio === 'indifferente'
                        ? 'tag__item__selected'
                        : 'tag__item__unselected'
                    "
                    v-on:click="choosePartOfDay('indifferente')"
                  >
                    <i
                      v-if="
                        $store.getters.partOfDaySelectedRadio === 'indifferente'
                      "
                      class="fas fa-check mr-2"
                    ></i
                    >Indifferente
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-6">
              <div class="">
                <h1 class="postcardpercorsi__title white">
                  Inserisci il codice del tuo itinerario
                </h1>

                <div
                  v-if="isLarge"
                  class="postcardpercorsipredefiniti__bar"
                ></div>
                <div class="postcardpercorsi__preview-txt mb-3">
                  Inserisci qua il codice dell'itinerario che hai creato per
                  poterlo visualizzare!
                </div>
                <form-group-input
                  class="no-border form-control-lg px-0"
                  placeholder="Codice..."
                  v-model="pathCodeInserted"
                  addon-left-icon="now-ui-icons objects_key-25"
                >
                </form-group-input>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div :class="{ 'text-left': isLarge, 'text-center': !isLarge }">
                <Button
                  size="small"
                  type="primary"
                  v-on:click="createPath()"
                  class="button_font mt-3"
                  >Crea itinerario
                </Button>
              </div>
            </div>
            <div class="col-6">
              <div :class="{ 'text-left': isLarge, 'text-center': !isLarge }">
                <Button
                  size="small"
                  type="primary"
                  v-on:click="checkCodeAndGetPath()"
                  class="button_font mt-3"
                  >Inserisci codice
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Component mobile-->
      <div class="d-block d-lg-none">
        <div class="postcardpercorsi light white mx-2" id="creaItinerario">
          <div class="postcardpercorsi__text">
            <div class="row" v-if="enabledRadioCreatePathOrInsertCode === '1'">
              <div class="col-12">
                <h1 class="postcardpercorsi__title__mobile white">
                  Crea un nuovo itinerario
                </h1>
                <div
                  v-if="isLarge"
                  class="postcardpercorsipredefiniti__bar"
                ></div>
                <div class="postcardpercorsi__preview-txt mb-3">
                  Creando un nuovo percorso hai la possibilità di inserire le
                  attività che più ti interessano e i posti che più vuoi
                  visitare in modo tale da rendere la tua esperienza ancora più
                  unica!
                </div>
                <div class="text-center">Quanto tempo hai a disposizione?</div>
                <ul class="postcardpercorsi__tagbox" v-if="this.config">
                  <li
                    v-for="timeSlot in this.config.omekaIDs.timeSlots"
                    :key="timeSlot"
                    :class="
                      $store.getters.timeSlotRadio === timeSlot
                        ? 'tag__item__selected'
                        : 'tag__item__unselected'
                    "
                    v-on:click="selectTimeSlot(timeSlot)"
                  >
                    <i
                      v-if="$store.getters.timeSlotRadio === timeSlot"
                      class="fas fa-check mr-2"
                    ></i
                    >{{ timeSlot }} ore
                  </li>
                  <li
                    :class="
                      $store.getters.timeSlotRadio === 'other'
                        ? 'tag__item__selected'
                        : 'tag__item__unselected'
                    "
                    v-on:click="selectTimeSlot('other')"
                  >
                    <i
                      v-if="$store.getters.timeSlotRadio === 'other'"
                      class="fas fa-check mr-2"
                    ></i
                    >Altro (fascia oraria personalizzata)
                  </li>
                </ul>

                <div v-if="$store.getters.timeSlotRadio === 'other'">
                  <div class="row mt-4">
                    <!-- <h6 class="col-12">
                      <b>Seleziona il tempo che hai a disposizione</b>
                    </h6> -->
                    <div
                      v-if="!okTimeAvailable"
                      class="col-12 errorMessage fade-in-text text-center"
                    >
                      <h5><b>Devi inserire una fascia oraria corretta!</b></h5>
                    </div>
                  </div>

                  <div class="row pt-3">
                    <div class="col-12 text-center">
                      <b>dalle ore</b><br />
                      <vue-timepicker
                        v-model="startAvailableTimeValue"
                        format="HH:mm"
                      ></vue-timepicker>
                    </div>
                  </div>

                  <div class="row align-items-center pt-3 pb-3">
                    <div class="col-12 text-center">
                      <b>alle ore</b><br />
                      <vue-timepicker
                        v-model="endAvailableTimeValue"
                        format="HH:mm"
                      ></vue-timepicker>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-12">
                      Hai selezionato di essere disponibile dalle ore
                      {{ startAvailableTimeValue.HH }} e
                      {{ startAvailableTimeValue.mm }} alle ore
                      {{ endAvailableTimeValue.HH }} e
                      {{ endAvailableTimeValue.mm }}.
                    </div>
                  </div>
                </div>

                <div v-if="forOrSixHoursSelected">
                  <div class="mt-3 text-center">
                    Dicci quando vorresti svolgere le attività
                  </div>
                  <ul class="postcardpercorsi__tagbox">
                    <li
                      :class="
                        $store.getters.partOfDaySelectedRadio === 'mattina'
                          ? 'tag__item__selected'
                          : 'tag__item__unselected'
                      "
                      v-on:click="choosePartOfDay('mattina')"
                    >
                      <i
                        v-if="
                          $store.getters.partOfDaySelectedRadio === 'mattina'
                        "
                        class="fas fa-check mr-2"
                      ></i
                      >Mattina
                    </li>
                    <li
                      :class="
                        $store.getters.partOfDaySelectedRadio === 'pomeriggio'
                          ? 'tag__item__selected'
                          : 'tag__item__unselected'
                      "
                      v-on:click="choosePartOfDay('pomeriggio')"
                    >
                      <i
                        v-if="
                          $store.getters.partOfDaySelectedRadio === 'pomeriggio'
                        "
                        class="fas fa-check mr-2"
                      ></i
                      >Pomeriggio
                    </li>
                    <li
                      :class="
                        $store.getters.partOfDaySelectedRadio === 'indifferente'
                          ? 'tag__item__selected'
                          : 'tag__item__unselected'
                      "
                      v-on:click="choosePartOfDay('indifferente')"
                    >
                      <i
                        v-if="
                          $store.getters.partOfDaySelectedRadio ===
                          'indifferente'
                        "
                        class="fas fa-check mr-2"
                      ></i
                      >Indifferente
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div :class="{ 'text-left': isLarge, 'text-center': !isLarge }">
                  <Button
                    size="small"
                    type="primary"
                    v-on:click="createPath()"
                    class="button_font mt-3"
                    >Crea itinerario
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="postcardpercorsi light white mx-2"
          id="inserisciCodiceItinerario"
        >
          <div class="postcardpercorsi__text">
            <div class="row" v-if="enabledRadioCreatePathOrInsertCode === '1'">
              <div class="col-12">
                <h1 class="postcardpercorsi__title__mobile white">
                  Recupera un itinerario che hai già creato
                </h1>

                <div
                  v-if="isLarge"
                  class="postcardpercorsipredefiniti__bar"
                ></div>
                <div class="postcardpercorsi__preview-txt mb-3">
                  Inserisci qua il codice dell'itinerario che hai creato per
                  poterlo visualizzare!
                </div>
                <form-group-input
                  class="no-border form-control-lg px-0"
                  placeholder="Codice..."
                  v-model="pathCodeInserted"
                  addon-left-icon="now-ui-icons objects_key-25"
                >
                </form-group-input>
                <div :class="{ 'text-left': isLarge, 'text-center': !isLarge }">
                  <Button
                    size="small"
                    type="primary"
                    v-on:click="checkCodeAndGetPath()"
                    class="button_font mt-3"
                    >Inserisci codice
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Fine component mobile-->

      <modal
        :show.sync="modals.itineraryNotReceivedWithError"
        headerClasses="justify-content-center"
        @close="modals.itineraryNotReceivedWithError = false"
      >
        <h4 slot="header" class="title title-up text-center">Errore!</h4>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <h6 class="itineraryCode">
                  Si è verificato un errore durante recupero del tuo itinerario.
                </h6>
                <p>Riprovare più tardi.</p>
              </div>
            </div>
          </div>
        </div>

        <template slot="footer">
          <Button
            size="small"
            type="danger"
            v-on:click="modals.itineraryNotReceivedWithError = false"
            class="mx-1"
            >Chiudi
          </Button>
        </template>
      </modal>

      <modal
        :show.sync="modals.notCorrectCustomTimeSlot"
        headerClasses="justify-content-center"
        @close="modals.notCorrectCustomTimeSlot = false"
      >
        <h4 slot="header" class="title title-up text-center">Attenzione!</h4>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <h6 class="itineraryCode">
                  Devi inserire una fascia oraria corretta.
                </h6>
              </div>
            </div>
          </div>
        </div>

        <template slot="footer">
          <Button
            size="small"
            type="danger"
            v-on:click="modals.notCorrectCustomTimeSlot = false"
            class="mx-1"
            >Chiudi
          </Button>
        </template>
      </modal>

      <modal
        :show.sync="modals.itineraryCodeNotValid"
        headerClasses="justify-content-center"
        @close="modals.itineraryCodeNotValid = false"
      >
        <h4 slot="header" class="title title-up text-center">Errore!</h4>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <h6 class="itineraryCode">
                  Il codice inserito non è valido, si prega di inserire un
                  codice corretto.
                </h6>
              </div>
            </div>
          </div>
        </div>

        <template slot="footer">
          <Button
            size="small"
            type="danger"
            v-on:click="modals.itineraryCodeNotValid = false"
            class="mx-1"
            >Chiudi
          </Button>
        </template>
      </modal>

      <modal
        :show.sync="modals.confirmLessTimeAndRecreatePath"
        headerClasses="justify-content-center"
        @close="modals.confirmLessTimeAndRecreatePath = false"
      >
        <h4 slot="header" class="title title-up text-center">Attenzione!</h4>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <p>
                  Il tempo a disposizione inserito è inferiore rispetto a prima,
                  se prosegue perderà l'itinerario creato.
                </p>
                <p>Proseguire?</p>
              </div>
            </div>
          </div>
        </div>

        <template slot="footer">
          <Button
            size="small"
            type="danger"
            v-on:click="modals.confirmLessTimeAndRecreatePath = false"
            class="mx-1"
            >Chiudi
          </Button>
          <Button
            size="small"
            type="primary"
            v-on:click="initPathAndGoToCreatePath()"
            class="mx-1"
            >Prosegui
          </Button>
        </template>
      </modal>

      <modal
        :show.sync="modals.pleaseSelectTimeSlot"
        headerClasses="justify-content-center"
        @close="modals.pleaseSelectTimeSlot = false"
      >
        <h4 slot="header" class="title title-up text-center">Attenzione!</h4>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 text-center">
                <p>
                  Per poter proseguire è necessario selezionare una fascia
                  oraria.
                </p>
              </div>
            </div>
          </div>
        </div>

        <template slot="footer">
          <Button
            size="small"
            type="danger"
            v-on:click="modals.pleaseSelectTimeSlot = false"
            class="mx-1"
            >Chiudi
          </Button>
        </template>
      </modal>
    </div>
  </div>
  <div v-else>
    <h4 slot="header" class="title title-up text-center">
      Caricamento in corso
    </h4>
    <div class="loader">
      <svg class="circular">
        <circle
          class="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="5"
          stroke-miterlimit="10"
        ></circle>
      </svg>
    </div>
  </div>
</template>

<script>
const Common = require("@/Common.vue").default;

import $ from "jquery";
import { Button } from "element-ui";
import { Checkbox, Radio, Modal, FormGroupInput } from "../components";
import "v-alert-resource/dist/v-alert-resource.css";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import store from "../store";
import Vuex from "vuex";
import router from "../router";
import { config } from "../utils/config";

export default {
  name: "Percorsi",
  bodyClass: "percorsi-page",

  components: {
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    Button,
    VueTimepicker,
    Modal,
    FormGroupInput,
  },

  data() {
    return {
      isLoadingAree: true,
      isLoadingPOIPivot: true,

      filteredPOI: [],

      startAvailableTimeValue: {
        HH: "09",
        mm: "30",
      },
      endAvailableTimeValue: {
        HH: "15",
        mm: "00",
      },

      okTimeAvailable: true,

      modals: {
        //oggetto usato per mostrare i modals
        insertCodeModal: false,
        itineraryNotReceivedWithError: false,
        itineraryCodeNotValid: false,
        confirmLessTimeAndRecreatePath: false, // modal che chiede all'utente se è sicuro di voler diminuire il tempo e perdere l'itinerario
        pleaseSelectTimeSlot: false,
        notCorrectCustomTimeSlot: false,
      },

      pathCodeInserted: "", //variabile usata per contenere il codice del percorso inserito dell'utente

      enabledRadio: null,
      enabledRadioCreatePathOrInsertCode: "1",
      partOfDaySelectedRadio: "mattina",
      forOrSixHoursSelected: true,

      windowWidth: 0,
      config: null,
    };
  },

  computed: {
    ...Vuex.mapGetters([]),

    // timeSlotRadio(){
    //   return this.$store.state.timeSlotRadio;
    // },

    isLarge() {
      return this.windowWidth >= 768;
    },

    loadedMatrixPOI() {
      return store.state.vroomCostMatricesTimeBetweenPOI !== null;
    },

    loadedMatrixAreas() {
      return store.state.costMatricesTimeBetweenAreas !== null;
    },

    loadedMatrixForVROOM() {
      return store.state.costMatricesTimeBetweenPOI !== null;
    },

    allActivitiesAvailable: function () {
      //Le attività disponibili devono essere trovate per i POI filtrati: prima c'era this.$store.state.POIpivot
      var allActivitiesAvailable = [];

      for (var i = 0; i < this.filteredPOI.length; i++) {
        for (var j = 0; j < this.filteredPOI[i].mis.length; j++) {
          var activityDurations = new Array(
            this.filteredPOI[i].mis[j]["geo:Durata"].length
          );

          activityDurations[j] = this.filteredPOI[i].mis[j]["geo:Durata"];

          allActivitiesAvailable.push({
            activityName: this.filteredPOI[i].mis[j]["o:title"],
            activityID: this.filteredPOI[i].mis[j]["o:id"],
            activityDurations: activityDurations,
            activitySelected: false,
          });
        }
      }

      return allActivitiesAvailable;
    },

    timeAvailableTemp() {
      //tempo disponibile selezionati in base al click sul bottone
      if (this.$store.getters.timeSlotRadio === "4") {
        var humanReadable = this.getCustomTime();

        var hAvailable = humanReadable.hours;
        var minAvailable = humanReadable.minutes;

        if (hAvailable > 0 || (hAvailable === 0 && minAvailable >= 10)) {
          var timeMinutes = hAvailable * 60 + minAvailable; //converto l'orario inserito in minuti
          var timeAvailable = {
            hour: hAvailable,
            minutes: minAvailable,
            milliseconds: timeMinutes * 60000, //converto i minuti in millisecondi
          };

          return timeAvailable.milliseconds;
        } else {
          return 0;
        }
      } else {
        var timeMinutes = this.$store.getters.timeSlotRadio * 60; //6 ore in minuti
        var timeAvailable = {
          hour: this.$store.getters.timeSlotRadio,
          minutes: 0,
          milliseconds: timeMinutes * 60000, //converto i minuti in millisecondi
        };

        return timeAvailable.milliseconds;
      }

      return 0;
    },
  },

  async created() {
    var self = this;

    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

    Common.getElemsByClass(this, config.omekaIDs.omekaIDpoiPIVOT, (res) => {
      store.state.POIpivot = res.body;
      self.isLoadingPOIPivot = false;

      Array.prototype.forEach.call(store.state.POIpivot, (poi) => {
        if (poi.hasOwnProperty("o-module-mapping:marker")) {
          // Get module-mapping
          Common.getElemByUrl(
            self,
            poi["o-module-mapping:marker"][0]["@id"],
            (r2) => {
              poi.marker = r2.body;
            }
          );
        } else {
          /*Il POI non ha nessuna coordinata*/
        }

        poi.visitPOI = false;
        poi.numberOfActivitiesSelectedInPOI = 0;

        /*chiedo l'immagine dei POI*/
        Common.getElementImages(this, poi, (mediaList) => {
          poi.media = mediaList;
        });
      });
    });

    Common.getElemsByClass(this, config.omekaIDs.omekaIDarea, (res) => {
      store.state.aree = res.body;
      self.isLoadingAree = false;
    });
  },

  beforeMount() {
    //chiedo gli esperimenti perchè magari non sono mai andato nella pagina dedicata a loro prima d'ora, ma mi servono qua
    Common.getElemsByClass(this, config.omekaIDs.omekaIDattivita, (res) => {
      store.state.esperimenti = res.body;
      store.commit("setActivitiesInPOI");
      // this.filteredPOI = store.state.POIpivot;
      // this.initializeMarkersOfFilteredPOI();

      // self.activitiesLoaded = true;
      // self.isLoadingEsperimenti = false;
    });
  },

  mounted() {
    this.$store.commit("removeOtherObjects");
    this.config = config;

    if (store.getters.timeSlotRadio === null) {
      var timeSlotRadio = this.config.omekaIDs.timeSlots[0];
      this.$store.commit("setTimeSlotRadio", { timeSlotRadio });
    }

    if (this.$store.getters.viewFeaturesProgettoTesi) {
      this.selectTimeSlot("other");
    }

    this.getCostMatricesOmeka();

    if (this.$store.getters.getCustomTimeSlot) {
      var hours = this.$store.getters.getCustomTimeSlot.split("-");

      var startMin = hours[0].split(":");
      var endMin = hours[1].split(":");

      this.startAvailableTimeValue.HH = startMin[0];
      this.startAvailableTimeValue.mm = startMin[1];
      this.endAvailableTimeValue.HH = endMin[0];
      this.endAvailableTimeValue.mm = endMin[1];
    }

    // check time slot
    if (
      this.$store.state.timeSlotRadio == 12 ||
      this.$store.state.timeSlotRadio == "other"
    ) {
      this.forOrSixHoursSelected = false;

      if (this.$store.state.timeSlotRadio == 12) {
        var partOfDaySelectedRadio = "indifferente";
        this.$store.commit("setPartOfDaySelectedRadio", {
          partOfDaySelectedRadio,
        });
      } else {
        var startH = this.startAvailableTimeValue.HH !== "" ? this.startAvailableTimeValue.HH : "00";
        var startM = this.startAvailableTimeValue.mm !== "" ? this.startAvailableTimeValue.mm : "00";
        var endH = this.endAvailableTimeValue.HH !== "" ? this.endAvailableTimeValue.HH : "00";
        var endM = this.endAvailableTimeValue.mm !== "" ? this.endAvailableTimeValue.mm : "00";

        var partOfDaySelectedRadio =
          startH + ":" + startM + "-" + endH + ":" + endM;

        this.$store.commit("setPartOfDaySelectedRadio", {
          partOfDaySelectedRadio,
        });
      }
    } else {
      this.forOrSixHoursSelected = true;
    }
  },

  methods: {
    selectTimeSlot(timeSlotRadio) {
      this.$store.commit("setTimeSlotRadio", { timeSlotRadio });

      if (timeSlotRadio == 12 || timeSlotRadio == "other") {
        this.forOrSixHoursSelected = false;

        if (timeSlotRadio == 12) {
          var partOfDaySelectedRadio = "indifferente";
          this.$store.commit("setPartOfDaySelectedRadio", {
            partOfDaySelectedRadio,
          });
        } else {
        var startH = this.startAvailableTimeValue.HH !== "" ? this.startAvailableTimeValue.HH : "00";
        var startM = this.startAvailableTimeValue.mm !== "" ? this.startAvailableTimeValue.mm : "00";
        var endH = this.endAvailableTimeValue.HH !== "" ? this.endAvailableTimeValue.HH : "00";
        var endM = this.endAvailableTimeValue.mm !== "" ? this.endAvailableTimeValue.mm : "00";

        var partOfDaySelectedRadio =
          startH + ":" + startM + "-" + endH + ":" + endM;

          this.$store.commit("setPartOfDaySelectedRadio", {
            partOfDaySelectedRadio,
          });
        }
      } else {
        this.forOrSixHoursSelected = true;

        if (
          this.$store.getters.partOfDaySelectedRadio !== "indifferente" &&
          this.$store.getters.partOfDaySelectedRadio !== "mattina" &&
          this.$store.getters.partOfDaySelectedRadio !== "pomeriggio"
        ) {
          var partOfDaySelectedRadio = "mattina";
          this.$store.commit("setPartOfDaySelectedRadio", {
            partOfDaySelectedRadio,
          });
        }
      }
    },

    getCostMatricesOmeka() {
      Common.getElemsByClass(
        this,
        config.omekaIDs.omekaIDmatriciSpostamenti,
        (res) => {
          store.state.omekaCsvMatrixes = res.body;
          store.commit("initCostMatrixPOI");
          store.commit("initCostMatrixAreas");
        }
      );
    },

    choosePartOfDay(partOfDaySelectedRadio) {
      store.commit("setPartOfDaySelectedRadio", { partOfDaySelectedRadio });
    },

    goToSelezionaItinerarioPredefinito: function () {
      location.href = "#selezionaItinerarioPredefinitoMobile";
    },

    goToCreaItinerario: function () {
      location.href = "#creaItinerario";
    },

    goToInserisciCodiceItinerario: function () {
      location.href = "#inserisciCodiceItinerario";
    },

    createPath() {
      if (this.$store.getters.timeSlotRadio === "other") {
        var humanReadable = this.getCustomTime();

        var startH = this.startAvailableTimeValue.HH !== "" ? this.startAvailableTimeValue.HH : "00";
        var startM = this.startAvailableTimeValue.mm !== "" ? this.startAvailableTimeValue.mm : "00";
        var endH = this.endAvailableTimeValue.HH !== "" ? this.endAvailableTimeValue.HH : "00";
        var endM = this.endAvailableTimeValue.mm !== "" ? this.endAvailableTimeValue.mm : "00";

        var partOfDaySelectedRadio =
          startH + ":" + startM + "-" + endH + ":" + endM;

        var timeStart =
        startH +
          ":" +
          startM;
        var timeEnd =
          endH + ":" + endM;

        var customTimeSlot = timeStart + "-" + timeEnd;

        var partOfDaySelectedRadio = customTimeSlot;
        this.$store.commit("setPartOfDaySelectedRadio", { partOfDaySelectedRadio });

        // this.$store.state.preferredPartOfDay = partOfDaySelectedRadio;
        this.$store.commit("setCustomTimeSlot", { customTimeSlot });

        var hAvailable = humanReadable.hours;
        var minAvailable = humanReadable.minutes;

        if (hAvailable > 0 || (hAvailable === 0 && minAvailable >= 10)) {
          this.modals.notCorrectCustomTimeSlot = false;

          if (this.$store.getters.timeSlotRadio !== null) {
            if (
              this.$store.state.oldTimeAvailable !== null &&
              this.oldTimeIsMoreThanNew()
            ) {
              this.modals.confirmLessTimeAndRecreatePath = true;
            } else {
              this.goToCreatePath();
            }
          } else {
            this.modals.pleaseSelectTimeSlot = true;
          }

        } else {
          this.modals.notCorrectCustomTimeSlot = true;
        }
      } else if (this.$store.getters.timeSlotRadio !== null) {
        if (
          this.$store.state.oldTimeAvailable !== null &&
          this.oldTimeIsMoreThanNew()
        ) {
          this.modals.confirmLessTimeAndRecreatePath = true;
        } else {
          this.goToCreatePath();
        }
      } else {
        this.modals.pleaseSelectTimeSlot = true;
      }
    },

    oldTimeIsMoreThanNew() {
      var oldHourToMillis = this.$store.state.oldTimeAvailable.hour * 3600000; //1 ora corrisponde a 3600000
      var oldMinToMillis = this.$store.state.oldTimeAvailable.minutes * 60000;
      var oldTimeMillis = oldHourToMillis + oldMinToMillis;

      var newHourToMillis = null; //1 ora corrisponde a 3600000
      var newMinToMillis = null;
      var newTimeMillis = null;

      if (this.$store.getters.timeSlotRadio === "other") {
        var humanReadable = this.getCustomTime();

        newHourToMillis = humanReadable.hours * 3600000;
        newMinToMillis = humanReadable.minutes * 60000;
        newTimeMillis = newHourToMillis + newMinToMillis;
      } else {
        var time = this.$store.getters.timeSlotRadio;

        newHourToMillis = time * 3600000;
        newMinToMillis = 0;
        newTimeMillis = newHourToMillis + newMinToMillis;
      }

      return oldTimeMillis > newTimeMillis;
    },

    goToCreatePath() {
      this.$store.state.preferredPartOfDay =
        this.$store.getters.partOfDaySelectedRadio;

      if (this.$store.getters.timeSlotRadio === "other") {
        var humanReadable = this.getCustomTime();
        
        var startH = this.startAvailableTimeValue.HH !== "" ? this.startAvailableTimeValue.HH : "00";
        var startM = this.startAvailableTimeValue.mm !== "" ? this.startAvailableTimeValue.mm : "00";
        var endH = this.endAvailableTimeValue.HH !== "" ? this.endAvailableTimeValue.HH : "00";
        var endM = this.endAvailableTimeValue.mm !== "" ? this.endAvailableTimeValue.mm : "00";

        var customTimeSlot = startH + ":" + startM + "-" + endH + ":" + endM;

        this.$store.commit("setCustomTimeSlot", { customTimeSlot });

        var hAvailable = humanReadable.hours;
        var minAvailable = humanReadable.minutes;

        if (hAvailable > 0 || (hAvailable === 0 && minAvailable >= 10)) {
          this.okTimeAvailable = true;

          var timeMinutes = hAvailable * 60 + minAvailable; //converto l'orario inserito in minuti
          var timeAvailable = {
            hour: hAvailable,
            minutes: minAvailable,
            milliseconds: timeMinutes * 60000, //converto i minuti in millisecondi
          };

          this.$store.state.timeAvailable = timeAvailable;
          this.$store.state.oldTimeAvailable = timeAvailable;

          router.push({
            name: "creapercorso",
          });

        } else {
          this.okTimeAvailable = false;
        }
      } else if (this.$store.getters.timeSlotRadio !== "other") {
        var customTimeSlot = null;
        this.$store.commit("setCustomTimeSlot", { customTimeSlot });

        var timeMinutes = this.$store.getters.timeSlotRadio * 60; //6 ore in minuti
        var timeAvailable = {
          hour: this.$store.getters.timeSlotRadio,
          minutes: 0,
          milliseconds: timeMinutes * 60000, //converto i minuti in millisecondi
        };

        this.$store.state.timeAvailable = timeAvailable;
        this.$store.state.oldTimeAvailable = timeAvailable;

        router.push({
          name: "creapercorso",
        });
      }
    },

    initPathAndGoToCreatePath() {
      //SINCRONIZZO I FILTERED POI CON LA LISTA DELLE ATTIVITA SELEZIONATE

      store.state.activitiesSelectedList = []; //inizializzo la lista di ttività selezionate

      Array.prototype.forEach.call(store.state.POIpivot, (poi) => {
        poi.visitPOI = false;

        Array.prototype.forEach.call(poi.mis, (activity) => {
          activity.selected = false;
          poi.poiHasActivitiesSelected = false;
        });
      });

      this.$store.state.remainingTimeAvailable = this.timeAvailableTemp;
      this.$store.state.areasWithSomethingSelected = [];

      this.goToCreatePath();
    },

    getCustomTime() {
      var timeStartHourAndMinutes =
        this.startAvailableTimeValue.HH +
        ":" +
        this.startAvailableTimeValue.mm +
        ":00";
      var timeEndHourAndMinutes =
        this.endAvailableTimeValue.HH +
        ":" +
        this.endAvailableTimeValue.mm +
        ":00";

      store.commit("setCustomTimeWindow", {startHH: this.startAvailableTimeValue.HH, startMM: this.startAvailableTimeValue.mm, endHH: this.endAvailableTimeValue.HH, endMM: this.endAvailableTimeValue.mm});

      var timeStart = new Date(
        "Mon Jan 01 2007 " + timeStartHourAndMinutes + " GMT+0530"
      ).getTime();
      var timeEnd = new Date(
        "Mon Jan 01 2007 " + timeEndHourAndMinutes + " GMT+0530"
      ).getTime();
      var hourDiff = timeEnd - timeStart; //in ms
      var minDiff = hourDiff / 60 / 1000; //in minutes
      var hDiff = hourDiff / 3600 / 1000; //in hours
      var humanReadable = {};
      humanReadable.hours = Math.floor(hDiff);
      humanReadable.minutes = minDiff - 60 * humanReadable.hours;

      return humanReadable;
    },

    selectDefaultPath() {
      this.currentPage = "selectDefaultPath";
      router.push({ path: "/elencopercorsi" });
    },

    checkCodeAndGetPath() {
      if (this.pathCodeInserted.trim().length !== 0) {
        var self = this;

        $.ajax({
          url: "/geodidalab/api/itinerari/" + this.pathCodeInserted,
          type: "GET",
          success: function (result) {
            if (result !== null) {
              var itinerario = JSON.parse(result);
              var itineraryAlreadyExist = true;
              var itineraryCode = self.pathCodeInserted;

              store.state.sottoitinerari[0] = itinerario;

              //store.state.itinerarioPredefinito = this.itinerari[index];
              store.commit("setItinerarioVROOM", {
                itinerarioVROOM: itinerario,
              });

              router.push({
                name: "sintesiitinerario",
                params: {
                  itineraryAlreadyExist,
                  itineraryCode,
                },
              });
            } else {
              self.modals.itineraryCodeNotValid = true;
            }
          },
          error: function (error) {
            self.modals.itineraryNotReceivedWithError = true;
          },
        });

        this.modals.insertCodeModal = false;

        this.currentPage = "selectExistingPath";
      } else {
        //il codice inserito contiene solo spazi
        this.modals.itineraryCodeNotValid = true;
      }
    },
  },
};
</script>

<style>
.button_font {
  font-family: "Baloo 2";
  /*font-weight: bold;*/
  font-size: 0.84rem;
}

.centerTimePicker {
  margin-left: auto;
  margin-right: auto;
}

.errorMessage {
  color: #e95e38;
}

.fade-in-text {
  display: inline-block;
  animation: fadeIn linear 0.5s;
  -webkit-animation: fadeIn linear 0.5s;
  -moz-animation: fadeIn linear 0.5s;
  -o-animation: fadeIn linear 0.5s;
  -ms-animation: fadeIn linear 0.5s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: #e3913b;
  color: #fff;
  border-radius: 20px;
}

.vue__time-picker-dropdown,
.vue__time-picker .dropdown {
  border-radius: 5px;
}

.vue__time-picker input.display-time {
  border-radius: 5px;
}

.vue__time-picker .controls {
  bottom: 30px !important;
}
</style>
